import { c as _c } from "react/compiler-runtime";
import { Divider, Popover, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { DatePicker } from '@/components/date/datePicker';
import { dayjs, type Dayjs } from '@/utils/dayjs';
import { TimePicker } from './timePicker';
interface DateTimePopoverProps {
  value: Dayjs;
  onChange: (value: Dayjs) => void;
  anchorEl: HTMLElement | null;
  open: boolean;
  maxDate?: Dayjs;
  minDate?: Dayjs;
  title?: string;
}
export const DateTimePopover = t0 => {
  const $ = _c(11);
  const {
    value,
    onChange,
    anchorEl,
    open,
    maxDate,
    minDate,
    title
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = value.valueOf();
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== anchorEl || $[3] !== maxDate || $[4] !== minDate || $[5] !== onChange || $[6] !== open || $[7] !== t1 || $[8] !== title || $[9] !== value) {
    t2 = <DateTimePopoverContent key={t1} value={value} onChange={onChange} anchorEl={anchorEl} open={open} maxDate={maxDate} minDate={minDate} title={title} />;
    $[2] = anchorEl;
    $[3] = maxDate;
    $[4] = minDate;
    $[5] = onChange;
    $[6] = open;
    $[7] = t1;
    $[8] = title;
    $[9] = value;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
const DateTimePopoverContent = t0 => {
  const $ = _c(39);
  const {
    value,
    onChange,
    anchorEl,
    open,
    maxDate,
    minDate,
    title
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = value.year();
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const year = t1;
  const month = value.month() + 1;
  let t2;
  if ($[2] !== value) {
    t2 = value.date();
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const day = t2;
  let t3;
  if ($[4] !== day || $[5] !== month || $[6] !== year) {
    t3 = {
      year,
      month,
      day
    };
    $[4] = day;
    $[5] = month;
    $[6] = year;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const [selectedDate, setSelectedDate] = useState(t3);
  const [selectedTime, setSelectedTime] = useState(value);
  let t4;
  if ($[8] !== onChange || $[9] !== selectedDate.day || $[10] !== selectedDate.month || $[11] !== selectedDate.year || $[12] !== selectedTime) {
    t4 = () => {
      const updatedDate = dayjs.utc().year(selectedDate.year).month(selectedDate.month - 1).date(selectedDate.day).hour(selectedTime.hour()).minute(selectedTime.minute());
      onChange(updatedDate);
    };
    $[8] = onChange;
    $[9] = selectedDate.day;
    $[10] = selectedDate.month;
    $[11] = selectedDate.year;
    $[12] = selectedTime;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const handleClose = t4;
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      gap: "12px",
      padding: "4px"
    };
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== title) {
    t6 = title && <Typography variant="h3" sx={{
      margin: "24px 0 0 16px"
    }}>{title}</Typography>;
    $[15] = title;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      gap: "12px"
    };
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== selectedDate) {
    t8 = [selectedDate];
    $[18] = selectedDate;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = value_0 => {
      if (Array.isArray(value_0)) {
        setSelectedDate(value_0[0]);
      } else {
        setSelectedDate(prevState => value_0([prevState])[0]);
      }
    };
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== maxDate || $[22] !== minDate || $[23] !== t8) {
    t10 = <DatePicker maxDate={maxDate} minDate={minDate} enableYearSelection={true} value={t8} setValue={t9} />;
    $[21] = maxDate;
    $[22] = minDate;
    $[23] = t8;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Divider orientation="vertical" flexItem={true} />;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== selectedTime) {
    t12 = <TimePicker value={selectedTime} setValue={setSelectedTime} />;
    $[26] = selectedTime;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t10 || $[29] !== t12) {
    t13 = <Stack direction="row" sx={t7}>{t10}{t11}{t12}</Stack>;
    $[28] = t10;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t13 || $[32] !== t6) {
    t14 = <Stack sx={t5}>{t6}{t13}</Stack>;
    $[31] = t13;
    $[32] = t6;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== anchorEl || $[35] !== handleClose || $[36] !== open || $[37] !== t14) {
    t15 = <Popover disablePortal={true} open={open} anchorEl={anchorEl} onClose={handleClose}>{t14}</Popover>;
    $[34] = anchorEl;
    $[35] = handleClose;
    $[36] = open;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
};